import { DataGrid} from "@mui/x-data-grid";
import moment from "moment";

export const AlarmsCardModal = ({ alarms }) => {

    const columns = [
        {
            field: 'sensorName',
            headerName: 'Sensor',
            width: 180,
            editable: false,
            renderCell: (sensorName)=>
            {
                var ptName = sensorName.value;
                if(sensorName.value === 'Humidity 1')
                    ptName = 'Umidade 1';
                else if(sensorName.value === 'Humidity 2')
                    ptName = 'Umidade 2';
                else if(sensorName.value === 'Internal Temperature 1')
                    ptName = 'Temperatura 1';
                else if(sensorName.value === 'Internal Temperature 2')
                    ptName = 'Temperatura 2';              
                return ptName;
            }
        },
        {
            field: 'sensorValue',
            headerName: 'Valor',
            width: 100,
            editable: false
        },
        {
            field: 'sensorMinThreshold',
            headerName: 'Limiar Inferior',
            width: 125,
            editable: false
        },
        {
            field: 'sensorMaxThreshold',
            headerName: 'Limiar Superior',
            width: 125,
            editable: false
        },
        {
            field: 'dtEvent',
            headerName: 'Data',
            width: 180,
            editable: false,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY HH:mm:ss"),
        },
    ];

    return (
        <div style={{ height: '40vh', width: '90vw', marginLeft:'5%', marginTop:'-100px' }}>
            <DataGrid
                rows={alarms}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[4]}
            />
        </div>
    );
}